<template>
  <div class="instructions">
    <!-- 退货对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="show"
      width="50%"
      :before-close="handleClose"
    >
      <span>
        <div style="height: 50vh;overflow-y:scroll ;" v-html="goosHtml"></div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
    props:['isShow','goosHtml','title'],
    data(){
        return{
            show:false
        }
    },
    watch:{
        isShow(e){
           this.show=e
           
        }
    },
    methods:{
            // 叉号取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/box/instructions.vue